import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { useLocation, useNavigate } from 'react-router-dom';
import "../pagination/pagination.css"
import Pagination from '../pagination/pagination';
import Select from 'react-select';
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import moment from 'moment/moment';

const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL
const PropertyDashBoard = () => {
    return (
        <div className="p-3">

        </div>
    );
};
export default PropertyDashBoard;
